import React from "react";
import { useParams } from "react-router-dom";
import SubHeadingBanner from "../components/organisms/SubHeadingBanner";
import MnLink from "../components/atoms/MnLink";
import useScrollToTop from "../hooks/useScrollToTop";
import HeadingText from "../components/atoms/HeadingText";
import ParaText from "../components/atoms/ParaText";
import courseDetail from "../assets/images/course-detail.avif";
import useTranslate from "../hooks/useTranslate";
import imgMap from "../data/courses";

const CourseDetail = () => {
  const { courseName } = useParams();
  useScrollToTop();

  // Find the course with the matching slug
  const course = useTranslate("coursesPage.section.courses")?.find(
    (course) => course.slug === courseName
  );

  if (!course) {
    return (
      <div className="container mx-auto p-4 lg:p-8">Course not found.</div>
    );
  }

  return (
    <>
      <SubHeadingBanner
        imageSrc={courseDetail}
        head1="Home - Course Detail"
        head2="Course Detail"
      />
      <div className="container mx-auto p-4 lg:p-8">
        {/* Back Button */}
        <MnLink to="/courses" name=" &larr; Back to Courses" />

        {/* Hero Banner */}
        <div className="relative h-auto md:h-[400px] lg:h-[500px] w-full max-w-[1230px] mx-auto bg-gray-200 overflow-hidden mt-4">
          <img
            src={imgMap[course.imageId]}
            alt="Course Hero"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black opacity-20"></div>
        </div>

        {/* Course Title */}
        {/* <div className="text-center mt-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
            {course.title}
          </h1>
        </div> */}

        {/* Course Details */}
        <section className="my-8 lg:my-12">
          <div className="max-w-3xl mx-auto text-center px-4">
            <HeadingText variant="h2">{course.title} Overview</HeadingText>
            <ParaText>
              This course provides a comprehensive guide to {course.title}. It
              covers the basics as well as advanced concepts, ensuring that
              students acquire the necessary skills and knowledge to excel in{" "}
              {course.topics.map((topic, index) => (
                <React.Fragment key={index}>
                  {topic.name}
                  {index < course.topics.length - 1 ? ", " : ""}
                </React.Fragment>
              ))}
              .
            </ParaText>
          </div>
        </section>

        {/* What You Will Learn */}
        <section className="my-8 lg:my-12">
          <div className="max-w-3xl mx-auto px-4">
            <ul className="list-disc pl-5 space-y-4 text-gray-700 text-lg">
              {course.topics.map((topic, index) => (
                <li key={index} className="mb-4 list-none">
                  <HeadingText variant="h3">{topic.name}</HeadingText>
                  <ParaText>{topic.content}</ParaText>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </>
  );
};

export default CourseDetail;
